import React from 'react';
import "./scrollbar.css"
const BedRoomPopup = ({ data, onClose }) => {
  return (
    <div className=" fixed inset-0 font-jt flex items-center h-screen backdrop-blur-sm justify-center z-[100000] bg-black bg-opacity-50 ">
      <div className="bg-white  rounded-2xl shadow-md p-2 lg:p-6 w-[100vw] lg:w-[70vw]">
        <div className="px-3 lg:px-6 py-3 lg:py-4 flex items-center justify-between rounded-full lg:rounded-2xl lg:bg-gray-100">
          <h2 className="text-xl font-bold text-[24px] lg:text-[30px] mx-auto">Bedroom Information Detail</h2>
          <button
            className="text-gray-600 hover:text-gray-800"
            onClick={onClose}
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.0001 1.41666C13.918 1.41666 10.9051 2.3306 8.34245 4.04292C5.77979 5.75524 3.78243 8.18902 2.60297 11.0365C1.4235 13.884 1.1149 17.0173 1.71618 20.0401C2.31747 23.063 3.80164 25.8397 5.98101 28.0191C8.16038 30.1984 10.9371 31.6826 13.9599 32.2839C16.9828 32.8852 20.1161 32.5766 22.9636 31.3971C25.8111 30.2176 28.2448 28.2203 29.9572 25.6576C31.6695 23.095 32.5834 20.0821 32.5834 17C32.5834 12.867 30.9416 8.90335 28.0192 5.98091C25.0967 3.05847 21.133 1.41666 17.0001 1.41666ZM23.6683 21.6651C23.8036 21.7958 23.9116 21.9521 23.9858 22.1249C24.0601 22.2978 24.0991 22.4837 24.1008 22.6718C24.1024 22.8599 24.0666 23.0464 23.9953 23.2205C23.9241 23.3946 23.8189 23.5528 23.6859 23.6858C23.5529 23.8188 23.3947 23.924 23.2206 23.9952C23.0465 24.0665 22.86 24.1023 22.6719 24.1007C22.4837 24.099 22.2979 24.06 22.125 23.9857C21.9522 23.9115 21.7959 23.8035 21.6652 23.6682L17.0001 19.0032L12.335 23.6682C12.2043 23.8035 12.048 23.9115 11.8752 23.9857C11.7023 24.06 11.5164 24.099 11.3283 24.1007C11.1402 24.1023 10.9537 24.0665 10.7796 23.9952C10.6055 23.924 10.4473 23.8188 10.3143 23.6858C10.1813 23.5528 10.0761 23.3946 10.0048 23.2205C9.93361 23.0464 9.89777 22.8599 9.8994 22.6718C9.90103 22.4837 9.94011 22.2978 10.0144 22.1249C10.0886 21.9521 10.1965 21.7958 10.3318 21.6651L14.9969 17L10.3318 12.3349C10.1965 12.2042 10.0886 12.0479 10.0144 11.8751C9.94011 11.7022 9.90103 11.5163 9.8994 11.3282C9.89777 11.1401 9.93361 10.9536 10.0048 10.7795C10.0761 10.6054 10.1813 10.4472 10.3143 10.3142C10.4473 10.1812 10.6055 10.076 10.7796 10.0047C10.9537 9.93351 11.1402 9.89767 11.3283 9.8993C11.5164 9.90094 11.7023 9.94002 11.8752 10.0143C12.048 10.0885 12.2043 10.1964 12.335 10.3317L17.0001 14.9968L21.6652 10.3317C21.7959 10.1964 21.9522 10.0885 22.125 10.0143C22.2979 9.94002 22.4837 9.90094 22.6719 9.8993C22.86 9.89767 23.0465 9.93351 23.2206 10.0047C23.3947 10.076 23.5529 10.1812 23.6859 10.3142C23.8189 10.4472 23.9241 10.6054 23.9953 10.7795C24.0666 10.9536 24.1024 11.1401 24.1008 11.3282C24.0991 11.5163 24.0601 11.7022 23.9858 11.8751C23.9116 12.0479 23.8036 12.2042 23.6683 12.3349L19.0033 17L23.6683 21.6651Z"
                fill="#D00808"
              />
            </svg>
          </button>
        </div>
        <div className="px-2 lg:px-6 py-2 lg:py-4 overflow-auto max-h-[400px]  custom-scrollbar">
          <table className="w-full">
            <thead>
              <tr>
                <th className="py-2 text-[14px] lg:text-[20px]">Room Name</th>
                <th className="py-2 text-[14px] lg:text-[20px]">Room Type</th>
                <th className="py-2 text-[14px] lg:text-[20px]">Bed Type</th>
                <th className="py-2 text-[14px] lg:text-[20px]">Size</th>
                <th className="py-2 text-[14px] lg:text-[20px]">Quantity</th>
              </tr>
            </thead>
            <tbody>
              {(data || [])
                .filter((item) => {
                  const type = String(item.room_type || "").toUpperCase();
                  if (type === "BEDROOM" || type === "DORMITORY") return true;
                  return (item.bed || []).length > 0;
                })
                .map((item, index) => (
                <tr key={item.id || `${item.room_name}-${index}`} className='items-center text-center'>
                  <td style={{ textTransform: 'capitalize' }}  className="py-2 text-[14px] lg:text-[20px]">{item.room_name}</td>
                  <td style={{ textTransform: 'capitalize' }} className="py-2 text-[14px] lg:text-[20px]">{item.room_type}</td>
                  <td style={{ textTransform: 'capitalize' }} className="py-2 text-[14px] lg:text-[20px]">{item.bed?.[0]?.name || "—"}</td>
                  <td style={{ textTransform: 'capitalize' }} className="py-2 text-[14px] lg:text-[20px]">{item.bed?.[0]?.size || "—"}</td>
                  <td style={{ textTransform: 'capitalize' }} className="py-2 text-[14px] lg:text-[20px]">{item.bed?.[0]?.quantity ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
   
    </div>
  );
};

export default BedRoomPopup;
